module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    ref: "indexlist",
    staticClass: "index-list"
  }, [_c('div', {
    ref: "tt",
    staticClass: "tt"
  }), _vm._v(" "), _c('div', {
    ref: "letter-box",
    staticClass: "letter-box"
  }, _vm._l((_vm.selectionData), function(item, index) {
    return _c('p', {
      class: {
        'active': _vm.isActive[index]
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.letterHandle(index)
        }
      }
    }, [_c('i', [_vm._v(_vm._s(item.letter))])])
  }), 0), _vm._v(" "), _vm._l((_vm.selectionData), function(item, index) {
    return _c('dl', [_c('dt', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.letter))]), _vm._v(" "), _vm._l((item.arr), function(childe, cindex) {
      return _c('dd', [_vm._v(_vm._s(childe))])
    })], 2)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-505febe6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index-list/index.vue
// module id = 201
// module chunks = 0